import api from "./api";

export const getBatchList = async (data) => {
    return await api.get("/api/seo_batches/drd", {params:data});
};
